import { render, staticRenderFns } from "./WaitList.vue?vue&type=template&id=ecab9152"
import script from "./WaitList.vue?vue&type=script&lang=js"
export * from "./WaitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports